export const SkeletonLoader = () => (
  <div className="bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse w-full h-10 rounded-lg" />
);
